import { RootState } from "app/store";
import { setupTournamentSnapshot } from "db/info/tournamentInfo";
import { setupTourSnapshot } from "db/info/tourInfo";
import { setupPickemDetailsSnapshot } from "db/info/pickemInfo";
import { setupLeaderboardSnapshot } from "db/info/leaderboardInfo";
import { selectAllInitialTournamentsLoaded } from "selectors/TournamentLoading";

export const onStart = () => {
  setupTournamentSnapshot();
  setupTourSnapshot();
  setupLeaderboardSnapshot();
  setupPickemDetailsSnapshot();
};

export const selectInitialLoadComplete = (state: RootState) => {
  return (
    state.leaderboard.intialLoadComplete &&
    state.pickemDetails.intialLoadComplete &&
    state.tournament.intialLoadComplete &&
    state.tour.intialLoadComplete &&
    selectAllInitialTournamentsLoaded(state)
  );
};
